import client from '../client'

export const getDetailsKey = `${process.env.NEXT_PUBLIC_ACCOUNT_DOMAIN}/api/Accounts/GetDetails`

export async function getDetails() {
  return client(getDetailsKey)
}
